// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 836 ? "body-body" : chunkId) + "." + {"473":"16a1184f1358f3453645","836":"89017ecba0dddc1140fc"}[chunkId] + ".bundle.js";
};